// assum the user is already logged in
export async function AdminTable() {
    // The Data represented in this way:   
    // ["Hub", "Project", "Discipline", "Model Name", "LOD" - int, "Checked by", "Date of check" - time stamp, "Grade"]

    //let data = [
    //    ["אגף בינוי", "עוגן", "אדריכלות", "AR-BLD1", "100", "Omri Tsarfaty", "1/1/2022", "45.00"],
    //    ["אגף בינוי", "עוגן", "אדריכלות", "AR-BLD1", "100", "Omri Tsarfaty", "2/1/2022", "65.00"],
    //    ["אגף בינוי", "עוגן", "אדריכלות", "AR-BLD1", "100", "Omri Tsarfaty", "3/1/2022", "85.00"],
    //    ["אגף בינוי", "עוגן", "קונסטרוקציה", "AR-BLD1", "100", "Omri Tsarfaty", "3/1/2022", "20.00"],
    //    ["אגף בינוי", "עוגן", "קונסטרוקציה", "AR-BLD1", "100", "Omri Tsarfaty", "3/4/2022", "80.00"],
    //    ["אגף בינוי", "עוגן", "קונסטרוקציה", "AR-BLD1", "100", "Omri Tsarfaty", "3/8/2022", "100.00"],
    //    ["אגף בינוי", "עוגן", "אדריכלות", "AR-BLD4", "100", "Guy Hareuveni", "2/1/2022", "20.00"],
    //    ["אגף בינוי", "עוגן", "אדריכלות", "AR-BLD4", "100", "Guy Hareuveni", "3/1/2022", "50.00"],
    //    ["אגף בינוי", "עוגן", "אדריכלות", "AR-BLD4", "100", "Guy Hareuveni", "4/1/2022", "80.00"],
    //    ["אגף בינוי", "ספרייה", "אדריכלות", "AR", "100", "Guy Hareuveni", "2/1/2022", "20.00"],
    //    ["אגף בינוי", "ספרייה", "אדריכלות", "AR", "100", "Guy Hareuveni", "2/8/2022", "50.00"],
    //    ["אגף בינוי", "ספרייה", "אדריכלות", "AR", "100", "Guy Hareuveni", "2/16/2022", "80.00"],
    //    ["AMEC", "מרהס", "קונסטרוקציה", "ST-BLD1", "100", "Omri Tsarfaty", "1/1/2022", "25.00"],
    //    ["AMEC", "מרהס", "חשמל", "ST-BLD1", "100", "Yaniv Stoliar", "1/2/2022", "70.00"],
    //    ["ניסוי", "מרהס", "חשמל", "EL-BLD1", "100", "Omri Tsarfaty", "1/2/2022", "40.00"],
    //    ["אגף בינוי", "מגדל", "אדריכלות", "AR-FF", "100", "Yaniv Stoliar", "1/5/2022", "14.00"]
    //];



    var res;

    await fetch("/api/forge/datamanagement/dataFromDB")
        .then((response) => {
            return response.json();
        })
        .then((data) => {
            res = data;
        });
    
    return res;
}
